module.exports = __webpack_public_path__ + "static/media/tastecardbanner.3cb92e82.png";